module.exports = __webpack_public_path__ + "img/exam_bj.29d61295.png";